export default __webpack_public_path__ + "static/media/WayBackWhen.e1910c33.mp3";